import { render } from "./ListeTypeRamification.vue?vue&type=template&id=5ffb7290"
import script from "./ListeTypeRamification.vue?vue&type=script&lang=js"
export * from "./ListeTypeRamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__